import React, { useState } from 'react';
import { Header, Grid, Icon, Checkbox, Transition } from 'semantic-ui-react';



const CheckboxesGrid = ({ division, content, onChangeOptions, options, enabled }) => {
    return content.map((element) => {
        return (
            <React.Fragment>
                <Header as="h4" color="primary">
                    {element.label}
                </Header>
                <Grid columns="two">
                    {element.options.map(({ label, value }, _) => {
                        const lowerCaseLabel = element.label.toLowerCase();
                        const thisOne = options[division][lowerCaseLabel][value];
                        const isThisTheSelectAll = value === element['select_all'];
                        return (
                            <React.Fragment>
                                <Grid.Column>
                                    <Checkbox
                                        checked={thisOne}
                                        name={value}
                                        label={label}
                                        disabled={!enabled}
                                        onChange={() => {
                                            onChangeOptions(division, value, isThisTheSelectAll, lowerCaseLabel, element['select_all']);
                                        }}
                                    />
                                </Grid.Column>
                            </React.Fragment>
                        );
                    })}
                </Grid>
            </React.Fragment>
        );
    });
}

export default function OptionDrawer({ onChangeAllOptions, allOptions, options, onChangeOptions }) {
    const [expanded, setExpanded] = useState({ Sequences: false, Task: false, Event: false });

    const _options = [
        {
            label: 'Sequences',
            value: 'sequences',
            content: [
                {
                    label: 'Type',
                    select_all: 'type_all',
                    options: [
                        { label: 'All', value: 'type_all' },
                        { label: 'Email', value: 'type_email' },
                        { label: 'Call', value: 'type_call' },
                        { label: 'Text', value: 'type_text' },
                    ]
                },
            ]
        },
        {
            label: 'Task',
            value: 'tasks',
            content: [
                {
                    label: 'Type',
                    select_all: 'type_all',
                    options: [
                        { label: 'All', value: 'type_all' },
                        { label: 'Email', value: 'type_email' },
                        { label: 'Call', value: 'type_call' },
                        { label: 'To Do', value: 'type_todo' },
                        { label: 'Text', value: 'type_text' },
                    ],
                },
            ],
        },
        {
            label: 'Event',
            value: 'events',
            content: [],
        },
    ];

    const onToggleExpand = (label) => {
        setExpanded((prevState) => ({
            ...prevState,
            [label]: !prevState[label],
        }));
    };
    const getIndicatorColorClass = (label) => {
        switch (label) {
            case 'Sequences':
                return '--sequence';
            case 'Task':
                return '--task';
            case 'Event':
                return '--event';
            default:
                return '';
        }
    };
    return (
        <React.Fragment>
            {_options.map(({ label, value, content }) => {
                return (
                    <React.Fragment>
                        <Grid columns="two">
                            <Grid.Column width={9}>
                                <Header color="primary">
                                    <span className="LeftPanel__LabelWithIndicator">
                                    <Icon
                                        onClick={() => {
                                            onToggleExpand(label);
                                        }}
                                        disabled={content.length === 0}
                                        link
                                        size="small"
                                        className={`fas fa-circle-chevron-${expanded[label] ? 'up' : 'down'}`}
                                    />
                                        <span className={`LeftPanel__colorIndicatorLabel LeftPanel__colorIndicatorLabel${getIndicatorColorClass(label)}`} />
                                        {label}
                                    </span>
                                </Header>
                            </Grid.Column>
                            <Grid.Column width={3}>
                                <Checkbox
                                    toggle
                                    onClick={() => {
                                        onChangeAllOptions(value);
                                    }}
                                    checked={allOptions[value]}
                                />{' '}
                                {allOptions[value] ? 'On' : 'Off'}
                            </Grid.Column>
                        </Grid>
                        <Transition visible={expanded[label]} animation={'slide down'} unmountOnHide duration={'150'}>
                            <div>
                                <CheckboxesGrid
                                    division={value}
                                    content={content}
                                    options={options}
                                    onChangeOptions={onChangeOptions}
                                    enabled={allOptions[value]}
                                />
                            </div>
                        </Transition>
                    </React.Fragment>
                );
            })}
        </React.Fragment>
    );
}